import DOMPurify from 'dompurify';

/**
 * Listing descriptions are shown across many surfaces (admin edit preview,
 * public listing detail, collection detail, card previews). To keep the
 * visuals consistent we strip any inline color / size / face attributes —
 * these get injected when admins paste rich text from other apps (Airbnb,
 * Word, Google Docs) and make mid-paragraph spans render darker/lighter
 * than the rest, overriding our `[&_*]:text-inherit` utility.
 *
 * Only semantic formatting (bold, italic, lists, breaks, paragraphs) and
 * `data-*` attributes survive.
 */
export function sanitizeDescription(html) {
  if (!html) return '';
  return DOMPurify.sanitize(html, {
    FORBID_TAGS: ['font', 'style', 'script'],
    FORBID_ATTR: ['style', 'color', 'bgcolor', 'face', 'size', 'class'],
  });
}

export default sanitizeDescription;
